export default __webpack_public_path__ + "static/hero-8536b64d1113786410df96061b0d3432.jpg";